/**
 * Componente para mostrar nivel actual y progreso hacia siguiente nivel
 */

import { LevelProgress as LevelProgressType } from '../../types';
import './LevelProgress.css';

interface LevelProgressProps {
  levelProgress: LevelProgressType | null;
  loading?: boolean;
}

export function LevelProgress({ levelProgress, loading = false }: LevelProgressProps) {
  if (loading || !levelProgress) {
    return (
      <div className="level-progress">
        <div className="level-progress-loading">Cargando...</div>
      </div>
    );
  }

  const isMaxLevel = levelProgress.currentLevel === levelProgress.nextLevel;

  return (
    <div className="level-progress">
      <div className="level-progress-header">
        <span className="level-progress-label">Nivel</span>
        <span className="level-progress-current">{levelProgress.currentLevel}</span>
        {!isMaxLevel && (
          <>
            <span className="level-progress-separator">→</span>
            <span className="level-progress-next">{levelProgress.nextLevel}</span>
          </>
        )}
      </div>

      {!isMaxLevel ? (
        <>
          <div className="level-progress-bar-container">
            <div
              className="level-progress-bar"
              style={{ width: `${levelProgress.progressPercentage}%` }}
            />
          </div>
          <div className="level-progress-requirements">
            <div className="level-progress-requirement">
              <span className="requirement-label">Tiempo:</span>
              <span className="requirement-value">
                {levelProgress.timeProgress} / {levelProgress.timeRequired} min
              </span>
            </div>
            <div className="level-progress-requirement">
              <span className="requirement-label">Interacciones:</span>
              <span className="requirement-value">
                {levelProgress.interactionsProgress} / {levelProgress.interactionsRequired}
              </span>
            </div>
          </div>
        </>
      ) : (
        <div className="level-progress-max">
          <p>¡Has alcanzado el nivel máximo! 🎉</p>
        </div>
      )}
    </div>
  );
}

